import gql from 'graphql-tag';

export const BroadcastDetails = gql`
  fragment BroadcastDetails on Broadcast {
    id
    type
    title
    message
    delivery_body
    optional_channels
    mandatory_channels
    recipients {
      total
    }
    created_at
  }
`;

export const AlbumFolderBroadcastSequenceDetails = gql`
  fragment AlbumFolderBroadcastSequenceDetails on AlbumFolderBroadcastSequence {
    id
    album_folder {
      id
      name
      start_date
    }
    broadcast_sequence {
      id
      name
    }
    status
    excluded_recipients(slice: { limit: 999 }) {
      total
      records {
        id
        account {
          id
        }
      }
    }
    steps(slice: { limit: 999 }) {
      total
      records {
        id
        status
        broadcast_sequence_step {
          id
          title
        }
        scheduled_at
        completed_at
      }
    }
  }
`;

export const BroadcastSequenceStepAttachmentDetails = gql`
  fragment BroadcastSequenceStepAttachmentDetails on BroadcastSequenceStepAttachment {
    id
    asset_image {
      id
      url
      original_filename
    }
  }
`;

export const BroadcastSequenceStepDetails = gql`
  fragment BroadcastSequenceStepDetails on BroadcastSequenceStep {
    id
    type
    title
    message
    optional_channels
    days_offset
    days_offset_type
    scheduled_at
    attachments {
      total
    }
    matched_photos_filter
    transaction_items_filter
    display_discount_template_message
    attachments {
      total
      records {
        ...BroadcastSequenceStepAttachmentDetails
      }
    }
  }
  ${BroadcastSequenceStepAttachmentDetails}
`;

export const BroadcastSequenceDetails = gql`
  fragment BroadcastSequenceDetails on BroadcastSequence {
    id
    name
    steps(slice: { limit: 999 }) {
      total
      records {
        ...BroadcastSequenceStepDetails
      }
    }
    album_folder_broadcast_sequences(slice: { limit: 999 }) {
      total
      records {
        ...AlbumFolderBroadcastSequenceDetails
      }
    }
  }
  ${BroadcastSequenceStepDetails}
  ${AlbumFolderBroadcastSequenceDetails}
`;
